var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "header-search ml-md-24 ml-xl-80 align-self-center mr-xl-auto"
    },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.searchText,
            expression: "searchText"
          }
        ],
        staticClass: "form-control",
        attrs: {
          id: _vm.inputId,
          tabindex: "1",
          type: "text",
          placeholder: "Probeer 'Vuurdoop'"
        },
        domProps: { value: _vm.searchText },
        on: {
          keyup: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.submitSearch($event)
          },
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.searchText = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "search-submit", on: { click: _vm.submitSearch } },
        [_c("span", { staticClass: "arrow-right-small" })]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }